<template>
	<div class="sf-input-group-wrapper">
		<span class="sf-input-group-wrapper__label">{{ getMessage_('SWCC000106') }}</span>
		<div class="search-option-wrapper__normal">
			<el-select v-model="data" style="height: 40px" @change="change">
				<el-option label="ALL" value="ALL"></el-option>
				<el-option v-for="(useYn, index) in useYnList" :label="useYn.commCdName" :value="useYn.commCd" :key="index"></el-option>
			</el-select>
		</div>
	</div>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@common/UserGroupMap/store/helpers';
export default {
	data() {
		return {
			data: null
		};
	},
	computed: {
		...rootComputed,
		...serviceComputed
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		change(value) {
			this.setSearchParam_({ key: 'useYn', value: value }).then(() => {
				// console.log('change!!')
				this.$emit('reload', 1, 10);
			});
		}
	},
	created() {
		if (this.searchParams.useYn == null || this.searchParams.useYn == '') this.searchParams.useYn = 'Y';
		this.data = this.searchParams.useYn;
	}
};
</script>

<style></style>
